var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ClipboardService } from 'src/app/shared/clipboard.service';
var ClipboardDialogComponent = /** @class */ (function () {
    function ClipboardDialogComponent(dialogRef, data, clipboardService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.clipboardService = clipboardService;
        this.settings = {
            title: 'Copy to Clipboard',
            copyText: ''
        };
        this.settings = __assign({}, this.settings, data);
    }
    Object.defineProperty(ClipboardDialogComponent.prototype, "rowCount", {
        get: function () {
            var rows = this.settings.copyText.split(/\r?\n/);
            return rows.length + 1;
        },
        enumerable: true,
        configurable: true
    });
    ClipboardDialogComponent.prototype.ngOnInit = function () {
    };
    ClipboardDialogComponent.prototype.ngAfterViewInit = function () {
        var input = this.copyField.nativeElement;
        input.focus();
        input.select();
    };
    ClipboardDialogComponent.prototype.handleCopyClick = function () {
        var copied = this.clipboardService.copyInputFieldValue(this.copyField.nativeElement);
        this.close(copied);
    };
    ClipboardDialogComponent.prototype.handleCancelClick = function () {
        this.close(false);
    };
    ClipboardDialogComponent.prototype.close = function (copied) {
        this.dialogRef.close(copied);
    };
    return ClipboardDialogComponent;
}());
export { ClipboardDialogComponent };
